import * as moment from 'moment'
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui'
import * as React from 'react'
import styled from 'styled-components'

const CalendarAppointmentContainer = restProps => {

  const children = () => {
    return (
      <StyledCalendarContainerAppointment>

      </StyledCalendarContainerAppointment>
    )
  }


  return (
    <StyledCalendarContainerAppointment {...restProps}  />
  )
}
export default CalendarAppointmentContainer


const StyledCalendarContainerAppointment = styled(Appointments.Container)`
  display: flex;
`